import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const AmenitiesPanel = () => {
  const [AmenitiesData, setAmenitiesData] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/amenity_list"
      );
      setAmenitiesData(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_amenity",
        { amenity_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === "1") {
        setAmenitiesData((prevUser) =>
          prevUser.filter((user) => user.amenity_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Amenities");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };


  // Filter data based on selected amenity type
  const filteredAmenities = selectedType
    ? AmenitiesData.filter((item) => item.amenity_types === selectedType)
    : AmenitiesData;


  return (
    <div className="container mt-5">
      <div className="add-btn">
        <Link to="/Amenities-add">
          <button className="btn btn-success text-white">Add Amenities</button>
        </Link>
      </div>
  <div className="col-md-6 mb-3">
        <label className="mb-2">Amenities Types</label>
        <select
          className="form-control"
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
        >
          <option value="">All Amenities Types</option>
          <option value="Common Amenities">Common Amenities</option>
          <option value="Room Amenities">Room Amenities</option>
        </select>
      </div>
      <table className="table table-bordered table-striped">
        <thead className="">
          <tr>
            <th colSpan="4" className=" text-center bg-white fs-4 text-black">
              Amenities Table
            </th>
          </tr>
          <tr>
            <th className="text-white text-center table-custom">Amenities Image</th>
            <th className="text-white text-center table-custom">Title</th>
            <th className="text-white text-center table-custom">Description</th>
            <th className="text-white text-center table-custom">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredAmenities.map((Data, index) => (
            <tr key={index}>
              <td className="text-center">
                <img
                  src={`https://cyberathon.com/silverapartment/${Data.icon_amenty}`}
                  alt="Aminities"
                  style={{ width: "100px", height: "auto" }}
                />
              </td>
              <td className="text-center">
                <strong>{Data.title}</strong>
              </td>
              <td className="text-center">{Data.description}</td>
              <td className="text-center">
                <Link to={`/Amenities-view/${Data.amenity_id}`}>
                 <button
                  className="btn btn-info btn-sm me-1"
                >
                  <i className="fa-regular fa-eye text-white"></i>
                </button>
                </Link>
                <Link to={`/Amenities-edit/${Data.amenity_id}`}>
                  <button className="btn btn-primary btn-sm me-1">
                    <i className="fa-regular fa-pen-to-square text-white"></i>
                  </button>
                </Link>
                <button
                  className="btn btn-danger btn-sm me-1"
                  onClick={() => deleteUser(Data.amenity_id)}
                >
                  <i className="fa-regular fa-trash-can text-white"></i>
                </button>
               
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const AmenitiesAdd = () => {
 const users = {
    title: "",
    description: "",
    amenity_types:"",
  };
  const [AminitiesUser, setAminitiesUser] = useState(users);
  const [AminitiesImage, setAminitiesImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setAminitiesUser({ ...AminitiesUser, [name]: value });
    console.log(AminitiesUser);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setAminitiesImage(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", AminitiesUser.title);
    formData.append("description", AminitiesUser.description);
    formData.append("amenity_types", AminitiesUser.amenity_types);

    if (AminitiesImage) {
      formData.append("icon_amenty", AminitiesImage);
    }
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_amenity",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success === "1") {
        toast.success("Data Added Successfully!");
        setAminitiesImage(null);
        setPreviewImage(null);
        navigate("/Amenities");
      } else {
        toast.error(response.data.error || "Failed to add Near Point");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-header table-custom text-white">
          <h4 className="mb-0 text-white text-center">Add Amenities</h4>
        </div>

        <div className="card-body">
          <form className="row g-3" onSubmit={submitForm}>
            <div className="col-md-6">
              <label htmlFor="amenity_types" className="form-label">
                Amenities Types
              </label>
              <select
                className="form-control"
                id="amenity_types"
                name="amenity_types"
                value={AminitiesUser.amenity_types}
                onChange={inputHandler}
              >
                <option value="">Select Amenities Types</option>
                <option value="Common Amenities">Common Amenities</option>
                <option value="Room Amenities">Room Amenities</option>
              </select>
            </div>
                <div className="col-md-6">
              <label htmlFor="icon_amenty" className="form-label">
                Image
              </label>
              <input
                type="file"
                className="form-control"
                id="icon_amenty"
                accept="image/*"
                onChange={handleImageChange}
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  className="mt-2"
                  style={{ width: "100px", height: "auto" }}
                />
              )}
            </div>

            <div className="col-md-6">
              <label htmlFor="title" className="form-label">
                Title
              </label>
              <input
                type="text"
                className="form-control"
                id="title"
                name="title"
                placeholder="Enter title"
                value={AminitiesUser.title}
                onChange={inputHandler}
              />
            </div>

        

            <div className="col-md-6">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <input
                type="text"
                className="form-control"
                id="description"
                name="description"
                placeholder="Enter description"
                value={AminitiesUser.description}
                onChange={inputHandler}
              />
            </div>

            <div className="col-12 d-flex justify-content-end">
              <button type="submit" className="btn btn-success" style={{height:"40px"}}>
                Add Amenities
              </button>
              <div className="mb-3 ms-1">
                <Link to="/Amenities" className="btn btn-secondary">
                  Back
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const EditAmenities = () => {
  const [AminitiesImage, setAminitiesImage] = useState(null);
  const [AmenitiesUser, setAmenitiesUser] = useState({
    title: "",
    description: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setAmenitiesUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const AmenitiesInfoData = async () => {
      try {
        const response = await axios.post(
          `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_amenity_by_id`,
          {
            amenity_id: id,
          }
        );
        setAmenitiesUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    AmenitiesInfoData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("amenity_id", id);
    formData.append("title", AmenitiesUser.title);
    formData.append("description", AmenitiesUser.description);

    if (AminitiesImage) {
      formData.append("icon_amenty", AminitiesImage);
    }

    try {
      const response = await axios.post(
        `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_amenity`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success === "1") {
        toast.success(response.data.message || "Data updated successfully");
        navigate("/Amenities");
      } else {
        toast.error(response.data.message || "Failed to update Near Point");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      style={{
        display: "block",
        paddingRight: 18,
        paddingBottom: 50,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header table-custom text-white justify-content-center">
              <h5 className="modal-title">Edit Amenities</h5>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">
                  Image{" "}
                  <span className="text-danger">
                    (Image must be at least 90x100%)
                  </span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="icon_amenty"
                  onChange={(e) => setAminitiesImage(e.target.files[0])}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  value={AmenitiesUser.title}
                  onChange={changeHandler}
                  className="form-control"
                  name="title"
                  id="title"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  rows={5}
                  type="text"
                  value={AmenitiesUser.description}
                  onChange={changeHandler}
                  className="form-control"
                  name="description"
                  id="description"
                />
              </div>

            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button type="submit" className="btn btn-success">
                Update
              </button>
              <Link to="/Amenities">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};


export const ViewAminities = () => {
  const [AminitiesUser, setAminitiesUser] = useState({
    icon_amenty: "",
    title: "",
    description: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const AminitiesData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_amenity_by_id",
          {
            amenity_id: id,
          }
        );
        setAminitiesUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    AminitiesData();
  }, [id]);

  return (
    <div className="container mt-5">
       <div className="d-flex justify-content-between">
      <h2 className="mb-4">View Aminities</h2>
      <Link to="/Amenities" className="btn m-2">
            <button type="button" className="back-btn">Back</button>
      </Link>
</div>
      <div className="card p-3">
        <div>
        <img
          src={`https://cyberathon.com/silverapartment/${AminitiesUser.icon_amenty}`}
          alt="Banner"
          className="img-fluid rounded"
          style={{ maxWidth: "400px" }}
        />
      <h3 className="mt-3">{AminitiesUser.title}</h3>
      <p>{AminitiesUser.description}</p>
      </div>
      </div>
    </div>
  );
};